import { render } from "./railwayDetail.vue?vue&type=template&id=8aa19a42&scoped=true"
import script from "./railwayDetail.vue?vue&type=script&lang=js"
export * from "./railwayDetail.vue?vue&type=script&lang=js"

import "./railwayDetail.vue?vue&type=style&index=0&id=8aa19a42&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aa19a42"]])

export default __exports__